export default __webpack_public_path__ + "static/media/z-4-train.221a6ec3.png";